import React from 'react';

import styled from 'styled-components';

import { useAsset } from '~/techstyle-shared/react-assets';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';

import DiscoveryGuideFilterPill from './DiscoveryGuideFilterPill';

const StyledDiscoverGuideFilterPillList = styled.ul`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin: 8px 0;
  list-style: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const DiscoveryGuideFilterPills = () => {
  const { gridStyleGuide } = useBuilderConstructorGridInputs();
  const assetContainerName =
    gridStyleGuide?.assetContainers?.mobile ||
    gridStyleGuide?.assetContainers?.desktop;
  const mobileAssetContainer = useAsset(assetContainerName, {
    multi: true,
  });

  const mobileAssets = mobileAssetContainer?.data?.assets || [];

  return (
    <StyledDiscoverGuideFilterPillList>
      {mobileAssets.map((asset) => (
        <li key={asset.id}>
          <DiscoveryGuideFilterPill {...asset} />
        </li>
      ))}
    </StyledDiscoverGuideFilterPillList>
  );
};

export default DiscoveryGuideFilterPills;
